export const addNamespace = (namespace = "") => {
  return function withNamespace(fieldName) {
    return namespace ? `${namespace}.${fieldName}` : fieldName;
  };
};
